import sa from "sa-sdk-javascript"
import { SENSORLOG } from "@/constants"
import {
  onlineClassId,
  roomId,
  userId,
  nickname,
  lessonName
} from "@/utils/getWebserver"
const timestamp = parseInt(performance.timeOrigin + performance.now())
const sensorLog = {
  initSensor: () => {
    sa.init({
      server_url: "https://sensorsdata.vipkid.com.cn/sa",
      debug_mode_upload: process.env.NODE_ENV !== "production",
      show_log: false,
      is_single_page: true,
      is_track_device_id: true // login默认追踪设备id，但是在调用login时将userid与神策cookie绑定后无法获取设备id，is_track_device_id字段可以帮助追踪设备id
    })
    sa.login("vipkid_" + userId)
    sa.quick("autoTrack")
    sa.registerPage({
      product: SENSORLOG.product,
      role: "TEACHER",
      room_id: roomId,
      uid: userId,
      nickname,
      lesson_name: lessonName,
      class_id: onlineClassId,
      current_url: location.href,
      referrer: document.referrer,
      said: parseInt(timestamp + parseInt(userId)),
      time: timestamp,
      platform: navigator.userAgent,
      app_name: SENSORLOG.app_name,
      course_type: SENSORLOG.course_type,
      sdk_version: SENSORLOG.sdk_version
    })
  },
  track: (event_id, event_type, msg = {}, callback) => {
    let params = {}
    params.event_id = `${SENSORLOG.product}_${event_id}`
    params.event_type = event_type
    params.event_category = `${SENSORLOG.product}`
    params.msg = JSON.stringify(msg)
    sa.track("page_trigger", params)

    if (process.env.NODE_ENV === "development") {
      if (event_type === "init") {
        console.log("event_id", event_id)
        console.log(
          `%c [${event_id}]`,
          "color: orange;font-weight:bold;font-size:30px",
          msg
        )
      } else if (event_type === "successed") {
        console.log(
          `%c [${event_id}]`,
          "color: green;font-weight:bold;font-size:30px",
          msg
        )
      } else {
        console.log(
          `%c [${event_id}]`,
          "color: red;font-weight:bold;font-size:30px",
          msg
        )
      }
    }
  }
}

export default sensorLog
